import axios from "axios";
import { getApiLanguageId } from "../utils/apiLanguageId.js";

export default class ApiClient {

    constructor() {}

    request({ method, path, data, languageId: languageIdOverride } = {}) {
        if (!method) {
            method = 'GET';
        }

        const languageId =
            languageIdOverride !== undefined && languageIdOverride !== null && languageIdOverride !== ''
                ? languageIdOverride
                : getApiLanguageId();
        return axios.post('/api', { method, path, data, languageId })
    }
}
